/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Card, CardContent, FormControl, Grid, InputLabel, Link, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { resetSubproducersInfo } from '../../actions/actions';
import { fetchPolicyData } from '../../common/services/Services';
import { modernLinkRedirect } from '../../common/services/proxyServices';
import { cleanObject, findDisplayName, findProductByDisplayName, getCurrentPrismId, getSubproducers } from '../../common/utilities/CommonHelperUtil';
import { handleFormValidation, hasErrors } from '../../common/utilities/CustomValidatorUtil';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import { validationCheck } from '../../common/utilities/HandleVerifyUserUtil';
import DropdownFilter from '../../components/common/DropdownFilter/DropdownFilter';
import SearchResultsComponent from '../../components/SearchResultsComponent/SearchResultsComponent';
import productsData from '../../json/productSectionNameList.json';
import statesData from '../../json/states.json';
import constants from '../../constants';
import './AdvancedSearchPage.scss';

const AdvancedSearchPage = ({ refreshToken, openGlobalBanner, hideErrorBanner}) => {
  const riskStates = { None: 'None', ...statesData };
  const products = ['None', ...productsData.map(item => item.displayName)];
  const statuses = [
    { label: 'None', value: 'None' },
    { label: 'New', value: 'NEW' },
    { label: 'Rated', value: 'RATED' },
    { label: 'In-Force', value: 'INFORCE' },
    { label: 'Cancelled', value: 'CANCELLED' },
    { label: 'Expired', value: 'EXPIRED' },
    { label: 'Pending Cancel', value: 'PENCAN' }
  ];
  const dispatch = useDispatch();
  const selectedProfile = useSelector(state => state.selectedProfile);
  const agentData = useSelector((state) => state.agents);
  const subproducersData = useSelector((state) => state.subproducers);
  const enrollments = useSelector(state => state.enrollments);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [agent, setAgent] = useState('');
  const [subproducer, setSubproducer] = useState('');
  const [riskCity, setRiskCity] = useState('');
  const [riskState, setRiskState] = useState(''); 
  const [riskZip, setRiskZip] = useState(''); 
  const [searchResults, setSearchResults] = useState([]);
  const [policyDataLoading, setPolicyDataLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [policyQuoteStatus, setSelectedPolicyQuoteStatus] = useState('');
  const [isAgentDropdownOpen, setAgentDropdownOpen] = useState(false);
  const [isSubAgentDropdownOpen, setSubAgentDropdownOpen] = useState(false);
  const [startsWithSelected, setStartsWithSelected] = useState(true);
  const [exactMatchSelected, setExactMatchSelected] = useState(false);
  const [searchAllRecordsSelected, setSearchAllRecordsSelected] = useState(true);
  const [defaultRangeSelected, setDefaultRangeSelected] = useState(false);
  const username = enrollments.length > 0 ? getCurrentPrismId(enrollments) : '';
  const initialErrors = {
    dateofbirth: '',
    npn: '',
    riskzip: '',
    requiredfields: '',
    notFound: ''
  };
  const loaderGif = require('../../common/assets/img/loader.gif');
  const policyDataLoaderStyle = {
    backgroundImage: policyDataLoading ? `url(${loaderGif})` : 'none',
    backgroundPosition: '10px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5rem 1.5rem',
    paddingLeft: policyDataLoading ? '2.5rem' : '',
  }
  const {isLoading, setIsLoading, loaderStyle, errors, setErrors} = HandleFormUtil(initialErrors);
  const forwardArrow  = require('../../img/forward-arrow-blue.png');
  const errorIcon = require('../../common/assets/img/error-icon.png');
  // Set the default start date to the first day 18 months ago.
  const getEighteenMonthsAgo = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 18);
    return date.toISOString().slice(0, 10);
  };
  const todaysDate = new Date().toISOString().slice(0, 10);
  const [startDate, setStartDate] = useState(getEighteenMonthsAgo());
  const [endDate, setEndDate] = useState(todaysDate);

  const setToEmpty = (value, setStateFunction) => {
        if(value === 'None') {
          setStateFunction('');
        }
  }

  const handleChange = (event, setStateFunction, dropdownId) => {
    const newValue = event.target.innerText !== undefined && event.target.innerText !== '' ? event.target.innerText : event.target.value;
    setStateFunction(newValue);
    if(!dropdownId) {
      return;
    }
    switch (dropdownId) {
      case 'agent':
        setSubproducer('');
        dispatch(resetSubproducersInfo());
        setToEmpty(newValue, setStateFunction);
        break;
      case 'subproducer':
      case 'policyQuoteStatus':
      case 'product':
      case 'riskState':
        setToEmpty(newValue, setStateFunction);
        break;
      default:
        break;
    }
  };

  const setRequestCriteria = () => {
    const trimmedAgent = agent.split(',')[0];
    const trimmedSubproducer = subproducer.split(',')[0] === 'None' ? '' : subproducer.split(',')[0] ;
    const productCodes = findProductByDisplayName(selectedProduct, productsData);
    const criteria = {
      userId: username,
      primarySearchCriteria: {
        lastName: lastName,
        agentNumber: trimmedAgent,
      },
      optionalSearchCriteria: {
        subProducerCode: trimmedSubproducer,
        firstName: firstName,
        companyNumber: '',
        lob: {
          productCode: productCodes.productCode,
          sectionCode: productCodes.sectionCode
        },
        policyStatusCode: policyQuoteStatus,
        address: {
          city: riskCity,
          state: riskState,
          postalCode: riskZip,
        },
        transactionDateRange: {
          from: searchAllRecordsSelected ? getEighteenMonthsAgo() : startDate,
          to: searchAllRecordsSelected ? todaysDate : endDate
        }
      },
      flags: {
        lastNameExactMatch: exactMatchSelected
      }
    }

    return cleanObject(criteria);
  };

  const getPolicyData = async () => {
    let criteria = {}
    if(lastName === '' && (agent === '' || agent === 'None')) {
      setErrors((prevFormErrors) => ({
          ...prevFormErrors,
          'requiredfields': 'Enter at least one highlighted field to begin your search.',
      }));
      return null;
    }
    setErrors((prevFormErrors) => ({
        ...prevFormErrors,
        'requiredfields': '',
    }));
    criteria = setRequestCriteria(); 
    try {
      setPolicyDataLoading(true);
      const policyData = await fetchPolicyData(criteria);
      if(policyData.length > 0) {
        const updatedPolicyData = policyData[0] !== '' ? findDisplayName(policyData, productsData) : policyData;
        setSearchResults(updatedPolicyData);
        if(policyData.length === 1 && policyData[0] === '') {
          setErrors((prevFormErrors) => ({
            ...prevFormErrors,
            'notFound': 'No Results found. Try refining your search',
          }));
        } else {
          setErrors((prevFormErrors) => ({
            ...prevFormErrors,
            'notFound': ''
          }));
        }
      }
      setPolicyDataLoading(false);
    } catch (err) {
      openGlobalBanner(err);
      setPolicyDataLoading(false);
    }
  }

  const clearForm = () => {
    setFirstName('');
    setLastName('');
    setAgent('');
    setSubproducer('');
    setRiskCity('');
    setRiskState('');
    setRiskZip('');
    setSearchResults([]);
    setSelectedProduct('');
    setSelectedPolicyQuoteStatus('');
    setAgentDropdownOpen(false);
    setSubAgentDropdownOpen(false);
    setStartsWithSelected(true);
    setExactMatchSelected(false);
    setStartDate(getEighteenMonthsAgo());
    setSearchAllRecordsSelected(true);
    setDefaultRangeSelected(false);
    setEndDate(todaysDate);
    setErrors(initialErrors);
  };

  const validatePrimaryFields = () => {
    if (errors.requiredfields && (lastName !== '' || agent !== '')) {
        delete errors.requiredfields;
    }
  }

  useEffect(() => {
    dispatch(resetSubproducersInfo());
    if (agent !== '' && agent !== 'None' ) {
      validatePrimaryFields();
      getSubproducers(agent, username, setIsLoading, openGlobalBanner, hideErrorBanner, refreshToken, dispatch);
    }
  }, [agent, dispatch]);

  const onValidation = (event) => {
    validatePrimaryFields();
    if(startDate > endDate) {
      setErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [event.target.id]: 'Date range \'From\' date must be before \'To\' date.',
      }));
    } else {
      handleFormValidation(event, setErrors, validationCheck);
    }
  };

  const agentCodes = Object.keys(agentData).length > 0  
    ? ['None', ...Object.values(agentData).map((data) => {      
        const displayName = data && data.mDisplayName ? data.mDisplayName : '';
        return `${data.mAgentCd}, ${displayName}`;
      })]
    : [];

  let subAgentCodes = [];
  if (Object.keys(subproducersData).length > 0) {
    subAgentCodes = (subproducersData[0] === undefined || subproducersData[0] === '')
      ? ['No results found.']
      : ['None', ...Object.values(subproducersData).map((data) => {
          const displayName = data && data.mDisplayName ? data.mDisplayName : '';
          return `${data.mSubproducerCd}, ${displayName}`;
        })];
  }

  const handleNavigate = async (policyQuoteNumber) => {
    if (username) {
      const newURL = selectedProfile?.amsuitePreference?.toLowerCase() !== constants.amsuite ? await advancedSearchNavigate(policyQuoteNumber, false, true) : await advancedSearchNavigate(policyQuoteNumber, true, false);
      return newURL;
    }
    return '';
  };

  const advancedSearchNavigate = async (policyQuoteNumber, gpa, pc) => {
    const url = await modernLinkRedirect(username, policyQuoteNumber, gpa, pc);
    if(gpa || pc) {
      return url;
    }
    window.open(url, '_self');
    return null;
  }

  return (
    <Box className='advancedsearch agent-ciam-container'>
      <Box className='advancedsearch-title'>Advanced Search</Box>
      <Card className='advancedsearch-card'>
        <CardContent className='advancedsearch-content'>
          <Box className='account-pref-card'>
            <Box style={{ display: 'flex', alignItems: 'center' }}>
              <Box className='account-pref-card-title'>
                Enter a last name, business name or agent number.
              </Box>
              {(errors.requiredfields || errors.notFound) && (
                <>
                  <img
                    alt='error icon'
                    className='erroricon'
                    src={errorIcon}
                  />
                  <span className='top-level-errormsg'>
                    {errors.requiredfields || errors.notFound}
                  </span>
                </>
              )}
            </Box>
            <Box className='advancedsearch-sub-message'>
              Use other fields to refine your results (up to 50 displayed).
            </Box>
          </Box>
          <Grid className='advancedsearch-policy-details' container spacing={3}>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <label htmlFor='lastName' className='advancedsearch-label'>Last name, business name or LLC</label>
                <input maxLength={40} id='lastName' className={errors.requiredfields ? 'advancedsearch-input inputBox errorfocus' : 'advancedsearch-input inputBox'} placeholder='Enter Last name, business name or LLC' value={lastName} onChange={(e) => handleChange(e, setLastName, null)} onBlur={onValidation}/>
              </Box>
            </Grid>
            <Grid className='advancedsearch-column' item xs={4}>
              <Box className='advancedsearch-field'>
                <FormControl className='primary-select' variant='outlined'>
                  <label
                    htmlFor='agentNumber'
                    className='advancedsearch-label'>
                    Agent number
                  </label>     
                  { agentCodes &&
                    <DropdownFilter 
                      errorClass={errors.requiredfields ? 'errorfocus' : ''}
                      agentData={agentCodes}
                      handleChange={(event) => handleChange(event, setAgent, 'agent')}
                      selectedValue={agent}
                      isOpen={isAgentDropdownOpen}
                      setDropdownOpen={setAgentDropdownOpen}
                      placeholderText='Enter or select number'
                      >
                    </DropdownFilter>
                  }
                </FormControl>
              </Box>
            </Grid>
            <Grid className='advancedsearch-column' item xs={4}>
              <Box className='advancedsearch-field'>
                <label
                  htmlFor='subAgentNumber'
                  className='advancedsearch-label'>
                  Sub-producer code
                </label> 
                { isLoading  &&  
                  <Box className='loading-box' style={loaderStyle}></Box>
                }    
              {(subAgentCodes  && !isLoading ) && 
                <FormControl className='primary-select' variant='outlined'>
                    <DropdownFilter 
                        agentData={subAgentCodes}
                        handleChange={(event) => handleChange(event, setSubproducer, 'subproducer')}
                        isOpen={isSubAgentDropdownOpen}
                        setDropdownOpen={setSubAgentDropdownOpen}
                        selectedValue={subproducer}
                        placeholderText='Enter or select code (if applicable)'
                        isDisabled={subAgentCodes.length === 0}
                      >
                    </DropdownFilter>
                </FormControl>
                }
              </Box>
            </Grid>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-radio-field'>
                <Box className='advancedsearch-radio-row'>
                  <label className='advancedsearch-radio-label'>
                    <input 
                      type='radio' 
                      className='advancedsearch-radio' 
                      name='searchType' 
                      checked={startsWithSelected} 
                      value='startsWith' 
                      onChange={() => {
                        setStartsWithSelected(true);
                        setExactMatchSelected(false);
                      }}                     
                    />
                    <Box className='advancedsearch-radio-label-text'>Starts with</Box>
                  </label>
                  <label className='advancedsearch-radio-label'>
                    <input 
                      type='radio' 
                      className='advancedsearch-radio' 
                      name='searchType' 
                      checked={exactMatchSelected}
                      value='exactMatch' 
                      onChange={() => {
                        setStartsWithSelected(false);
                        setExactMatchSelected(true);
                      }} 
                    />
                    <Box className='advancedsearch-radio-label-text'>Exact match</Box>
                  </label>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <hr className='advancedsearch-divider' />
          <Box className='account-pref-card-title'>
            Refine your search <span className='advancedsearch-radio-text'>(optional)</span>
          </Box>
          <Grid container spacing={3} className='advancedsearch-risk-location'>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <label htmlFor='firstName' className='advancedsearch-label'>First name</label>
                <input maxLength={20} id='firstName' className='advancedsearch-input inputBox' placeholder='Enter first name' value={firstName} onChange={(e) => handleChange(e, setFirstName, null)}/>
              </Box>
            </Grid>
            <Grid className='advancedsearch-risk-column' item xs={4}>
              <Box className='advancedsearch-field'>
                <FormControl className='primary-select' variant='outlined'>
                  <label
                    htmlFor='product'
                    className='advancedsearch-label'>
                    Product
                  </label>
                  {!selectedProduct &&
                    <InputLabel shrink={false} className='placeholder-text'>Enter or select product</InputLabel>
                  }
                  <Select
                    MenuProps={{   
                      classes:{paper:'paper-scroll'}   
                    }}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        color: '#282828',
                      },
                    }}  
                    IconComponent = {KeyboardArrowDown}
                    value={selectedProduct ?? ' '}
                    onChange={(e) => handleChange(e, setSelectedProduct, 'product')}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    className='select-dropdown'
                    placeholder='Enter or select Product'
                    >
                    {products && products.map((displayName, index) => (
                      <MenuItem className='dropdown-option' key={index} value={displayName}>
                        {displayName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid className='advancedsearch-risk-column'item xs={4}>
              <Box className='advancedsearch-field'>
                <FormControl className='primary-select' variant='outlined'>
                  <label
                    htmlFor='policyQuoteStatus'
                    className='advancedsearch-label'>
                    Policy or quote status
                  </label>
                  {!policyQuoteStatus &&
                    <InputLabel shrink={false} className='placeholder-text'>Enter or select status</InputLabel>
                  }                               
                  <Select
                    MenuProps={{   
                      classes:{paper:'paper-scroll'}   
                    }}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        color: '#282828',
                      },
                    }}  
                    IconComponent = {KeyboardArrowDown}
                    value={policyQuoteStatus ?? ' '}
                    onChange={(e) => handleChange(e, setSelectedPolicyQuoteStatus, 'policyQuoteStatus')}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    className='select-dropdown'
                    >
                    {statuses.map((status, index) => (
                      <MenuItem
                        className='dropdown-option'
                        key={index}
                        value={status.value}
                      >
                        {status.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3} className='advancedsearch-risk-location'>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <label htmlFor='riskCity' className='advancedsearch-label'>Risk location city</label>
                <input maxLength={40} id='riskCity' className='advancedsearch-input inputBox' placeholder='Enter risk location city' value={riskCity} onChange={(e) => handleChange(e, setRiskCity, null)}/>
              </Box>         
            </Grid>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <FormControl className='primary-select' variant='outlined'>
                  <label htmlFor='riskState' className='advancedsearch-label'>Risk location state</label>
                  {!riskState &&
                    <InputLabel shrink={false} className='placeholder-text'>Enter or select state</InputLabel>                            
                  }
                  <Select
                    MenuProps={{ classes:{paper:'paper-scroll'} }}
                    sx={{ '& .MuiSvgIcon-root': { color: '#282828', } }}  
                    IconComponent= {KeyboardArrowDown}
                    value={riskState ?? ' '}
                    onChange={(e) => handleChange(e, setRiskState, 'riskState')}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    className='select-dropdown'
                  >
                    {riskStates && Object.keys(riskStates).map((state) => (
                      <MenuItem className='dropdown-option' key={state} value={state}>
                        {state}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <label htmlFor='riskZip' className='advancedsearch-label'>Risk location ZIP</label>
                <input id='riskzip' maxLength={5} className={errors.riskzip ? 'advancedsearch-input inputBox errorfocus' : 'advancedsearch-input inputBox'} placeholder='Enter risk location ZIP'  value={riskZip} onChange={(e) => handleChange(e, setRiskZip, null)} onBlur={onValidation}/>
                {errors.riskzip && (
                  <span className='errormsg'>{errors.riskzip}</span>
                )}  
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3} className='advancedsearch-risk-location'>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <label className='advancedsearch-radio-label date-range'>
                  <input 
                    type='radio' 
                    className='advancedsearch-radio' 
                    name='dateRange' 
                    value='allRecords' 
                    checked={searchAllRecordsSelected} 
                    onChange={() => {
                      setSearchAllRecordsSelected(true);
                      setDefaultRangeSelected(false);
                    }}                  
                  />
                  <Box className='advancedsearch-radio-label-text'>All available records (recommended) <br/> <span className='advancedsearch-radio-text'>All searchable records from the past 18 months</span></Box>
                </label>
              </Box>
            </Grid>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <label className='advancedsearch-radio-label date-range'>
                  <input 
                    type='radio' 
                    className='advancedsearch-radio' 
                    name='dateRange' 
                    value='defaultRange' 
                    checked={defaultRangeSelected} 
                    onChange={() => {
                      setSearchAllRecordsSelected(false);
                      setDefaultRangeSelected(true);
                    }}                  
                  />
                  <Box className='advancedsearch-radio-label-text'>Custom date range <br/> <span className='advancedsearch-radio-text'>Select dates using the calendar fields (last 18 months)</span></Box>
                </label>
              </Box>
            </Grid>
            <Grid className='advancedsearch-column-title' item xs={4}>
              <Box className='advancedsearch-field'>
                <Box className='advancedsearch-date-row'>
                  <input
                    id='daterange'
                    className={`${startDate ? 'advancedsearch-date-range advancedsearch-date-range--has-value' : 'advancedsearch-date-range'}${searchAllRecordsSelected ? ' advancedsearch-date-range-disabled' : ''}${errors.daterange ? ' advancedsearch-date-range advancedsearch-date-range--has-value errorfocus': ' advancedsearch-date-range'}`}
                    type='date'
                    name='startDate'
                    min={getEighteenMonthsAgo()}
                    value={startDate}
                    onBlur={onValidation}
                    onChange={(e) => handleChange(e, setStartDate, null)}
                 />
                  <span className='advancedsearch-date-range-separator'>to</span>
                  <input
                    id='daterange'
                    className={`${endDate ? 'advancedsearch-date-range advancedsearch-date-range--has-value' : 'advancedsearch-date-range'}${searchAllRecordsSelected ? ' advancedsearch-date-range-disabled' : ''}${errors.daterange ? ' advancedsearch-date-range advancedsearch-date-range--has-value errorfocus': ' advancedsearch-date-range'}`}
                    type='date'
                    name='endDate'
                    min={startDate}
                    value={endDate}
                    onBlur={onValidation}
                    onChange={(e) => handleChange(e, setEndDate, null)}
                  />
                </Box>
                {errors.daterange && (
                  <span className='errormsg'>{errors.daterange}</span>
                )}  
              </Box>
            </Grid>
          </Grid>
          <Grid className='advancedsearch-risk-location advancedsearch-buttons' container spacing={3}>
            <Grid className='advancedsearch-column-title back-link-column' item xs={4}>
              <Box className='advancedsearch-field advancedsearch-buttons-box'>
                <Box className='advancedsearch-buttons-box'>  
                  <img
                    className='back-link-img'
                    src={forwardArrow}
                    alt='back'
                    width='24px'
                    height='24px'/>
                  <Link
                    href={'/'}
                    className='back-link'
                    target='_self'
                  >
                    <span className='forward-link-text'>Back to home</span>
                  </Link>
                </Box>
              </Box>
            </Grid>
            <Grid className='advancedsearch-column-title empty-column' item xs={4}></Grid>
            <Grid className='advancedsearch-column-title buttons-column' item xs={4}>
              <Box className='advancedsearch-field buttons-field'>
                <Box className='advancedsearch-buttons-box'>
                  <Link
                    className='clear-link'
                    onClick={() => clearForm()}
                  >
                    <span className='forward-link-text'>Clear fields</span>
                  </Link>
                  <Button disableRipple className='advancedsearch-continue-button' style={policyDataLoaderStyle} disabled={hasErrors(errors)} onClick={() => getPolicyData()}>
                    Search
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {searchResults && (searchResults.length > 0 || !searchResults) && (
        <SearchResultsComponent searchResults={searchResults} handleNavigate={handleNavigate} ></SearchResultsComponent>
      )}
    </Box>
  );
};

export default AdvancedSearchPage;
